export enum ActivityLogType {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    ARCHIVE = 'ARCHIVE',
}

export const ActivityLogTypeName: Record<ActivityLogType, string> = {
    [ActivityLogType.CREATE]: 'created',
    [ActivityLogType.UPDATE]: 'updated',
    [ActivityLogType.DELETE]: 'deleted',
    [ActivityLogType.ARCHIVE]: 'archived',
};

export enum ActivityLogModelType {
    FORMULA = 'Formula',
    LABEL = 'Label',
    ALTERNATE = 'Alternate',
    FORMULA_LABEL = 'FormulaLabel',
    VARIANT = 'Variant',
    LABEL_VARIANT_TYPE = 'LabelVariantType',
    FORMULA_TAG = 'FormulaTag',
    FORMULA_AUDIENCE = 'FormulaAudience',
    ALTERNATE_TEXT = 'AlternateText',
}

export const ActivityLogModelName: Record<ActivityLogModelType, string> = {
    [ActivityLogModelType.FORMULA]: 'Message',
    [ActivityLogModelType.LABEL]: 'Label',
    [ActivityLogModelType.ALTERNATE]: 'Alternate',
    [ActivityLogModelType.FORMULA_LABEL]: 'Message label',
    [ActivityLogModelType.VARIANT]: 'Variant',
    [ActivityLogModelType.LABEL_VARIANT_TYPE]: 'Label variant',
    [ActivityLogModelType.FORMULA_TAG]: 'Message tag',
    [ActivityLogModelType.FORMULA_AUDIENCE]: 'Message audience',
    [ActivityLogModelType.ALTERNATE_TEXT]: 'Alternate text',
};

export enum AuditTrailTimeframeOptions {
    LIFETIME = 'lifetime',
    MONTH = 'month',
    WEEK = 'week',
}

export interface ActivtyLog {
    id: number;
    user_id: number;
    user_name: string;
    verb: ActivityLogType;
    object_type: ActivityLogModelType;
    object_id?: string;
    target_type: ActivityLogModelType;
    target_id: string;
    created_at: string;
    /** Set to true when this update approved/set the formula live. NOT currently returned by /activity-logs — backend follow-up needed to expose this field. */
    approved?: boolean;
    /** Formula name injected client-side by useSurfaceActivityLogsQuery. */
    formula_name?: string;
}

export interface ActivityLogFilters {
    target_id: string;
    target_model: string;
}
